import { ReactNode } from 'react';

import { Text } from '../../cdl/Text/Text';
import { Box } from '../ui/Box';

interface VerticalDetailProps {
    label: string;
    value?: ReactNode;
}

export const VerticalDetail = ({ label, value }: VerticalDetailProps) => {
    if (!value) {
        return null;
    }

    return (
        <Box display="grid">
            <Text fontWeight={600}>{label}</Text>
            <Box maxWidth="fit-content">
                <Text>{value}</Text>
            </Box>
        </Box>
    );
};
